import { render, staticRenderFns } from "./StandardComponent.vue?vue&type=template&id=c99bb292&"
import script from "./StandardComponent.vue?vue&type=script&lang=js&"
export * from "./StandardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports